<template>
    <div>
        <h3 style="padding-left:20px;">
            {{
            classId === "" || classId === null || classId === undefined
            ? "添加班级"
            : "编辑班级"
            }}
        </h3>
        <div class="inner-box">
            <h5 class="subtitle">请填写班级相关信息</h5>
            <div class="box">
                <BInputText
                  v-model="classInfo.trainClassName"
                  :maxLength="25"
                  :required="true"
                  label-text="班级名称"
                  placeholder="请输入名称"
                />
            </div>
            <div class="box">
            <BInputPullDown
                  label-name="课 程"
                  v-model="classInfo.trainCourseId"
                  :Options="trainCourseList"
                  :required="true"
                  placeholder="选择授课课程"
                />
            </div>
            <div class="box" v-if="classId === '' || classId === null || classId === undefined || this.startDate > nowDate || this.startDate === nowDate">
                <BInputDateRange
                  v-model="classTime"
                  :required="true"
                  from-text="有效期间"
                  to-text="至"
                  @startDateChange="startDateChange"
                  @endDateChange="endDateChange"
                />
            </div>            
            <div class="box" v-else-if="this.startDate < nowDate ">
                <BInputText label-text="有效期间"
                            :required="true"
                            :disabled="true"
                            v-model="classTime.from"/>
                            <span style="margin: 0 10px 0 10px;">至</span>
                <BInputDate 
                placeholder = "请选择日期"
                v-model="classTime.to"
                @dateChange="onDateTimeChange"
                />
            </div>
            <div class="box">
            <BInputPullDown
                  label-name="负责老师"
                  v-model="classInfo.classTeacherId"
                  :Options="trainTeacherList"
                  :required="true"
                  placeholder="选择负责老师"
                />
            </div>
            <div class="box-time">
                <div style="margin-top: 20px">
                    <label class="label-box-sign">签到设置</label>
                </div>
                <div>
                    <div
                      class="box-time-pick"
                      v-for="(item, index) in signList"
                      :key="'sign' + index"
                    >
                        <BInputTimePicker
                          v-model="item.from"
                          @startTimeChange="onStartOrdinaryTimeChange"
                        />
                        <label class="label-box">至</label>
                        <BInputTimePicker
                          v-model="item.to"
                          @startTimeChange="onEndOrdinaryTimeChange"
                        />
                        <BBtnIconAdd   v-if="index == 0" :clicked="addRow"  style="margin-left: 15px;"/>
                        <BBtnIconDelete v-if="index != 0" :hidden-key="index" :clicked="removeRow" style="margin-left:15px;" />
                    </div>
                </div>
            </div>
            <div class="search-result">
                <div class="search-functions-headers">
                    <div class="search-functions">
                        <BBtnPrimary style="margin-left: 50px;"
                                v-if="
                classId === '' || classId === null || classId === undefined
              "
                                :clicked="save"
                                btn-txt="立即添加"
                        />
                        <BBtnPrimary v-else :clicked="save" btn-txt="立即修改"/>
                        <BBtnPrimary :clicked="back" btn-txt="返回"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        classAddInit,
        saveOrUpdateClass,
        classDetail,
    } from "@/api/classManagement";
    import BInputText from "../../components2/BInputText";
    import BInputDateRange from "../../components2/BInputDateRange";
    import BInputDate from "../../components2/BInputDate";
    import BBtnPrimary from "../../components2/BBtnPrimary";
    import BInputTimePicker from "../../components2/BInputTimePicker";
    import BInputPullDown from "../../components2/BInputPullDown";
    import BBtnIconAdd from "../../components2/BBtnIconAdd";
    import BBtnIconDelete from "../../components2/BBtnIconDelete";
    import Vue from "vue";

    export default {
        name: "ClassManagementAdd",
        components: {
            BInputText,
            BInputDateRange,
            BBtnPrimary,
            BInputTimePicker,
            BInputPullDown,
            BBtnIconAdd,
            BBtnIconDelete,
            BInputDate,
        },
        data: () => ({
            // 班级信息
            classInfo: {
                classId: null,
                trainClassName: "",
                classTeacherId: "",
                startDate: "",
                endDate: "",
                trainCourseId: "",
            },
            // 负责人List
            trainTeacherList: [],
            // 课程List
            trainCourseList: [],
            // 班级param
            trainCourseParam: [],
            startDate:'',
            // 普通签到List
            signList: [
                {
                    from: "",
                    to: "",
                },
            ],
            classTime: {
                from: "",
                to: "",
            },
            // 班级id
            classId: null,
            nowDate:'',
            navi: [
                {name: "class-management"},
                {name: "class-management-add"},
            ],
        }),
        created() {
            if (sessionStorage.getItem("store")) {
                this.$store.replaceState(
                    Object.assign(
                        {},
                        this.$store.state,
                        JSON.parse(sessionStorage.getItem("store"))
                    )
                );
                sessionStorage.removeItem("store");
            }
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("store", JSON.stringify(this.$store.state));
            });
        },
        destroyed() {
            this.$store.commit("REMOVE_CLASSID");
        },
        // 页面载入之前
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                const params = {
                    classId: vm.$route.params.classId,
                };
                if (
                    params.classId !== null &&
                    params.classId !== "" &&
                    params.classId !== undefined
                ) {
                    // 把不为空的参数存入缓存
                    vm.$store.commit("SET_CLASS_MANAGE_DETAIL_PARAMS", params);
                }
                // 参数赋值
                if (
                    vm.$store.state.classManagement_classId !== undefined &&
                    vm.$store.state.classManagement_classId !== null &&
                    vm.$store.state.classManagement_classId !== ""
                ) {
                    
                    vm.classId = vm.$store.state.classManagement_classId;
                }
                vm.classAddInit();
                vm.getNowDate()
            });
        },
        beforeMount() {
            this.$store.commit('SET_NAVI_DATA', this.navi);
        },
        methods: {
            // 获取当前时间
            getNowDate(){
                var  date =  new  Date();
                var  seperator1 =  "-" ;
                var  year = date.getFullYear();
                var  month = date.getMonth() + 1;
                var  strDate = date.getDate();
                if  (month >= 1 && month <= 9) {
                    month =  "0"  + month;
                }
                if  (strDate >= 0 && strDate <= 9) {
                    strDate =  "0"  + strDate;
                }
               this.nowDate = year + seperator1 + month + seperator1 + strDate;
            },
            addRow() {
                var obj = {
                    from: "",
                    to: "",
                };
                if (this.signListTimeCheck()) {
                    this.signList.push(obj);
                }
            },
            signListTimeCheck() {
                for (var i = 0; i < this.signList.length; i++) {
                    if (this.signList[i].from === "" || this.signList[i].to === "") {
                        return false;
                    }
                }

                return true;
            },
            removeRow(index) {
                this.signList.splice(index, 1);
            },
            getClassId(data) {
                var classId = [];
                for (var dto of data) {
                    if (dto.booleanValue) {
                        classId.push(dto.value);
                    }
                }
                return classId;
            },
            async classAddInit() {
                const data = await classAddInit();
                this.trainTeacherList = data.data.trainTeacherList;
                this.trainCourseList = data.data.trainCourseList;
                if (
                    this.classId !== "" &&
                    this.classId !== null &&
                    this.classId !== undefined
                ) {
                    this.trainClassInfo(this.classId);
                }
            },
            // 班级详情
            async trainClassInfo(id) {
                var param = {
                    id: id,
                };
                const data = await classDetail(param);
                this.classInfo.trainClassName =  data.data.trainClassName,
                this.classInfo.classTeacherId =  data.data.classTeacherId,
                this.classInfo.trainCourseId =  data.data.trainCourseId,
                this.classTime.from = data.data.startDate;
                this.startDate = data.data.startDate;
                this.classTime.to = data.data.endDate;
                if (data.data.signInList.length > 0) {
                    this.signList = data.data.signInList;
                    this.ordinaryValue = true;
                }
            },
            // 返回
            back() {
                if (String(this.$route.path).indexOf("class-management-public") != -1 &&
                    this.classId !== null &&
                    this.classId !== "" &&
                    this.classId !== undefined) {
                        var obj = {
                            flag: 1,
                        };
                        this.$emit("openFlag", obj);
                    } else if (String(this.$route.path).indexOf("class-management-public") == -1 &&
                    this.classId !== null &&
                    this.classId !== "" &&
                    this.classId !== undefined){
                        this.$router.push({
                            name: "class-management-public",
                        });
                    } else {
                        this.$router.push({
                            name: "class-management",
                        });
                    }
            },
            save() {
                const param = {};
                if (this.saveCheck()) {
                    param.trainClassName = this.comUtils.trim(this.classInfo.trainClassName);
                    param.classTeacherId = this.classInfo.classTeacherId;
                    param.classTime = this.classInfo.classTime;
                    param.trainCourseId = this.classInfo.trainCourseId;
                    if (this.classTime.from) {
                        param.startDate = this.classTime.from;
                    } else {
                        param.startDate = null;
                    }
                    if (this.classTime.to) {
                        param.endDate = this.classTime.to;
                    } else {
                        param.endDate = null;
                    }
                    param.signInList = this.signList;
                    if (this.classId) {
                        param.id = this.classId;
                        this.saveOrUpdateClass(param);
                    } else {
                        this.saveOrUpdateClass(param);
                    }
                }
            },
            async saveOrUpdateClass(param) {
                const data = await saveOrUpdateClass(param);
                if (data.code === 0) {
                    Vue.prototype.$vsnackbar.show(data.msg);
                    this.back()
                } else {
                    Vue.prototype.$valertbar.show(data.msg);
                }
            },
            // 普通签到时间区间check
            singListCheckTime(signInList) {
                var time = 1;
                // 普通签到时间check
                if (signInList.length > 1) {
                    for (var i = 0; i < signInList.length; i++) {
                        for (var j = 0; j < signInList.length; j++) {
                            if (i === j) {
                                continue;
                            } else {
                                if (
                                    signInList[i].from <= signInList[j].to &&
                                    signInList[i].from >= signInList[j].to
                                ) {
                                    Vue.prototype.$valertbar.show("签到当前已选区间存在重复时间");
                                    time = 2;
                                    break;
                                } else if (
                                    signInList[i].to >= signInList[j].from &&
                                    signInList[i].from <= signInList[j].from
                                ) {
                                    Vue.prototype.$valertbar.show("签到当前已选区间存在重复时间");
                                    time = 2;
                                    break;
                                } else if (
                                    signInList[i].from <= signInList[j].from &&
                                    signInList[i].to >= signInList[j].to
                                ) {
                                    Vue.prototype.$valertbar.show("签到当前已选区间存在重复时间");
                                    time = 2;
                                    break;
                                } else if (
                                    signInList[i].from >= signInList[j].from &&
                                    signInList[i].to <= signInList[j].to
                                ) {
                                    Vue.prototype.$valertbar.show("签到当前已选区间存在重复时间");
                                    time = 2;
                                    break;
                                }
                            }
                        }
                    }
                }
                return time;
            },
            singTimeCheck(signInList) {
                // 位置签到时间check
                if (signInList.length > 0) {
                    for (var r = 0; r < signInList.length; r++) {
                        if (
                            signInList[r].from !== "" &&
                            signInList[r].from !== null &&
                            signInList[r].from !== undefined &&
                            signInList[r].to !== "" &&
                            signInList[r].to !== null &&
                            signInList[r].to !== undefined
                        ) {
                            if (signInList[r].from >= signInList[r].to) {
                                Vue.prototype.$valertbar.show("结束时间要大于开始时间");
                                return false;
                            }
                        }
                    }
                }
                return true;
            },
            // 保存check
            saveCheck() {
                // 班级名称check
                if (
                    this.classInfo.trainClassName === null ||
                    this.classInfo.trainClassName === "" ||
                    this.classInfo.trainClassName === undefined
                ) {
                    Vue.prototype.$valertbar.show("请输入班级名称");
                    return false;
                }
                // 课程check
                if (
                    this.classInfo.trainCourseId === null ||
                    this.classInfo.trainCourseId === "" ||
                    this.classInfo.trainCourseId === undefined
                ) {
                    Vue.prototype.$valertbar.show("请选择课程名称");
                    return false;
                }
                // 班级时间
                if (
                    this.classTime.from === "" ||
                    this.classTime.from === undefined ||
                    this.classTime.from === null
                ) {
                    Vue.prototype.$valertbar.show("请选择班级开始日期");
                    return false;
                }
                var endDay =
                    new Date().getDate().toString().length === 1
                        ? "0" + new Date().getDate()
                        : new Date().getDate();
                var today =
                    new Date().getFullYear() +
                    "-" +
                    (new Date().getMonth() + 1) +
                    "-" +
                    endDay;
                // 编辑课程
                // 修改课程时，只要培训时间没有做修改，过去时间是可以的。修改后的日期不能是过去时间
                if ((this.classId === null || this.classId === '' ||this.classId === undefined)|| this.startDate === this.nowDate || this.startDate >  this.nowDate) {
                    
                    if (
                        new Date(this.classTime.from).getTime() < new Date(today).getTime()
                    ) {
                        Vue.prototype.$valertbar.show("开始日期不能是过去日期");
                        return false;
                    }
                }
                
                if (
                    this.classTime.to === "" ||
                    this.classTime.to === undefined ||
                    this.classTime.to === null
                ) {
                    Vue.prototype.$valertbar.show("请选择班级结束日期");
                    return false;
                }
                if (
                    new Date(this.classTime.from).getTime() >
                    new Date(this.classTime.to).getTime()
                ) {
                    Vue.prototype.$valertbar.show("结束日期要大于或等于开始日期");
                    return false;
                }
                // 负责老师
                if (
                    this.classInfo.classTeacherId === null ||
                    this.classInfo.classTeacherId === "" ||
                    this.classInfo.classTeacherId === undefined
                ) {
                    Vue.prototype.$valertbar.show("请选择负责老师");
                    return false;
                }
                if (this.signListTimeCheck()) {
                    // 普通签到时间check
                    if (!this.singTimeCheck(this.signList)) {
                        return false;
                    }
                } else {
                    if(this.signList[0].from){
                        Vue.prototype.$valertbar.show("请填写签到的开始时间或结束时间");
                        return false;
                    }
                       
                }

                // 普通时间区间check
                if (this.singListCheckTime(this.signList, 1) === 2) {
                    return false;
                }

                return true;
            },

            startDateChange(value) {
                this.classTime.from = value;
            },
            endDateChange(value) {
                this.classTime.to = value;
            },

            onStartOrdinaryTimeChange(value) {
                console.log(value);
            },
            onEndOrdinaryTimeChange(value) {
                console.log(value);
            },
            onDateTimeChange(value){
                this.classTime.to = value
            }
        },
    };
</script>

<style scoped>
    .main2 {
        position: relative;
        /*margin: 5px 30px 5px 30px;*/
        padding-top: 28px;
        display: flex;
        flex-wrap: wrap;
    }

    .search-result {
        display: block;
        position: relative;
        margin: 30px 25px 5px 25px;
    }

    .search-functions-headers {
        position: relative;
        display: flex;
        justify-content: space-between;
        top: 0;
    }

    .search-functions {
        position: relative;
        top: 0;
        display: flex;
    }

    .search-result-summary {
        display: flex;
        align-items: center;
    }

    .search-result-summary .summary {
        margin: 0 50px 0 0;
    }

    .search-result-table {
        border-spacing: 0px;
        padding-bottom: 50px;
        width: 100%;
        margin-top: 10px;
    }

    .table-header-row {
        height: 67px;
        background: #f6f6f6;
    }

    .table-header-row th {
        text-align: left;
        padding: 10px;
    }

    .table-result-row {
        height: 78px;
        font-weight: 500;
        color: #333333;
    }

    .table-result-row td {
        border-bottom: 1px solid #ebebeb;
        padding: 10px;
        text-align: left;
    }

    .btn-detail {
        margin: 0 20px 0 20px;
        color: #0171a3;
        cursor: pointer;
    }

    .btn-delete {
        color: #fd1f58;
        cursor: pointer;
    }

    .box {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .box-time-pick {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .box-time-title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-left: 90px;
    }

    .box-left {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
        border-right: 1px solid black;
    }

    .box-right {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
    }

    .inner-box {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex-wrap: wrap;
        position: relative;
        justify-content: flex-start;
    }

    .label-box {
        color: #333333;
        text-align: right;
        font-size: 14px;
        margin: 0 10px 0 10px;
    }

    .label-box-sign {
        text-align: right;
        color: #333333;
        font-size: 14px;
        margin: 0 10px 0 23px;
    }

    .subtitle {
        color: #999999;
        margin: 15px 10px 15px 20px;
    }
    .box-time{
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
    }
</style>
